import React, { useEffect } from 'react';
import { Button } from '../components/ui/button';
import toast from 'react-hot-toast';

export default function TestNotification() {
  // Show a basic toast when the component mounts
  useEffect(() => {
    toast.success("Component loaded successfully");
  }, []);

  // Simple notification test
  const triggerBasicToast = () => {
    toast.success("This is a test toast notification");
    console.log("Basic toast triggered");
  };

  // Custom notification test with phone call styling
  const triggerCustomToast = () => {
    console.log("Triggering custom toast notification");
    
    toast.custom(
      (t) => (
        <div 
          className="fixed top-4 left-4 max-w-md w-full bg-white shadow-lg rounded-lg z-[9999]"
          style={{
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)"
          }}
        >
          <div className="p-4">
            <div className="flex items-start">
              <div className="flex-shrink-0 pt-0.5">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <div className="ml-3 flex-1">
                <p className="text-sm font-medium text-gray-900">TEST: Incoming Call</p>
                <p className="mt-1 text-sm text-gray-500">From: (555) 123-4567</p>
              </div>
              <div className="ml-4 flex-shrink-0 flex">
                <button
                  onClick={() => toast.dismiss(t.id)}
                  className="bg-red-100 hover:bg-red-200 text-red-800 px-3 py-1 rounded-full"
                >
                  Dismiss
                </button>
              </div>
            </div>
          </div>
        </div>
      ),
      { duration: 30000 }
    );
  };

  return (
    <div className="container p-8">
      <h1 className="text-2xl font-bold mb-6">Test Notifications</h1>
      <p className="mb-4">Open the browser console to see debug messages</p>
      
      <div className="flex flex-col gap-4">
        <div>
          <Button 
            onClick={triggerBasicToast}
            className="bg-blue-500 hover:bg-blue-600 text-white"
          >
            Show Basic Toast
          </Button>
        </div>
        
        <div>
          <Button 
            onClick={triggerCustomToast}
            className="bg-green-500 hover:bg-green-600 text-white"
          >
            Show Call Notification
          </Button>
        </div>
      </div>
      
      <div className="mt-8 p-4 border rounded bg-gray-50">
        <h2 className="text-lg font-semibold mb-2">Troubleshooting Tips</h2>
        <ul className="list-disc pl-5">
          <li>Make sure you don't have an ad blocker or popup blocker enabled</li>
          <li>Check that JavaScript is enabled</li>
          <li>Look for errors in your browser's developer console</li>
          <li>Try using a different browser if the issue persists</li>
        </ul>
      </div>
    </div>
  );
} 